import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../data/content";

export default function Faq() {
  return (
    <div data-testid="faq-page">
      <PageHeader
        overline="FAQ"
        title="Your questions, answered"
        subtitle="Everything you need to know about measures, grants, finance and how our free survey works."
      />

      <section className="py-16 md:py-24 bg-brand-cream">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="bg-white border border-stone-200 rounded-2xl px-6 overflow-hidden">
                  <AccordionTrigger className="font-outfit text-left text-lg font-medium text-brand hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-figtree text-stone-600 text-base pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-12 bg-brand rounded-2xl p-8 text-center relative overflow-hidden">
              <div className="absolute inset-0 grain-overlay" />
              <p className="font-figtree text-brand-cream/80 mb-5 relative">Still have a question? We're happy to help.</p>
              <Link to="/contact" data-testid="faq-cta-button" className="relative bg-brand-accent text-white hover:bg-brand-accenthover transition-colors rounded-full px-7 py-3.5 font-medium inline-flex items-center gap-2">
                Get in touch <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
